/**
 * @packageDocumentation useCanAccessBookkeeping
 *
 * This hook is used to check if the user has access to the bookkeeping module.
 * It checks if the user has the feature flag "Bookkeeping" at the moment.
 * More checks can be added in the future.
 *
 * @category Hook
 */
import { useHasBookkeeping } from './useFeatureFlag';

/**
 * This hook is used to check if the user has access to the bookkeeping module.
 *
 * ```tsx
 * import Icon from '~/hooks/useCanAccessBookkeeping';
 *
 * ...
 *
 *   const canAccess = useCanAccessBookkeeping();
 *
 * ```
 *
 * @returns {boolean} Returns true if the user has access to the bookkeeping module.
 */
const useCanAccessBookkeeping = () => {
  return useHasBookkeeping();
};
export default useCanAccessBookkeeping;
